import { SetFreespinsBetbarCommand } from "slotworks/commands/betbar/set-freespins-betbar-command";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";

export default class RecoverFreespinsMode extends State {

    public static SET_WINNINGS_TO_TOTAL_WIN: boolean = false;

    public onEnter() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as FreespinRecord;

        // Update smart button count
        SmartUIFlags.set(SmartUIFlag.FREE_SPINS, true);

        SetFreespinsBetbarCommand();

        // If we're about to recover into a retrigger, deduct it's awarded spins from the initial state.
        const retriggerResult = gameplay.getCurrentRecord().getResultsOfType(FreespinWinResult).pop();

        if (retriggerResult) {
            const totalFreespins = gameplay.getTotalFreespinsWon() - retriggerResult.freespinsWon;
            Components.betBar.setTotalFreespins(totalFreespins);
        }

        // Dont include current freespin as a played one
        Components.betBar.setFreespinsPlayed(Math.max(0, gameplay.getFreespinsPlayed()));

        let winnings = gameplay.getCurrentBranchWin();
        if (RecoverFreespinsMode.SET_WINNINGS_TO_TOTAL_WIN) {
            winnings = gameplay.getTotalWin();
        }
        winnings -= record.cashWon;

        Services.transaction.setWinnings(0, winnings).execute();
        Services.transaction.setBalance(gameplay.balance);

        this.recoverFreespinsElements();

        this.complete();
    }

    protected recoverFreespinsElements() {
        if (Layers.Background.hasScene("freespins")) {
            Layers.Background.jumpToScene("freespins");
        }
        if (Layers.MatrixBackground.hasScene("freespins")) {
            Layers.MatrixBackground.jumpToScene("freespins");
        }
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.jumpToScene("freespins");
        }

        Components.banner.setMode("freespins");
    }
}
